<button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title class="paymentHeader text-center bg-secondary dialogHeader text-white">Payment</h1>
<mat-dialog-content class="mb-4">
  <div class="paymentType text-center">
    <span>Payment Option: &nbsp;</span>
    <div class="custom-control custom-radio custom-control-inline">
      <input type="radio" [(ngModel)]="payment" value="CASH" id="customRadioInline1" name="payment"
        class="custom-control-input">
      <label class="custom-control-label" for="customRadioInline1">Cash</label>
    </div>
    <div class="custom-control custom-radio custom-control-inline">
      <input type="radio" [(ngModel)]="payment" value="CARD" id="customRadioInline2" name="payment"
        class="custom-control-input">
      <label class="custom-control-label" for="customRadioInline2">Card</label>
    </div>
    <div class="custom-control custom-radio custom-control-inline">
      <input type="radio" [(ngModel)]="payment" value="UPI" id="customRadioInline3" name="payment"
        class="custom-control-input">
      <label class="custom-control-label" for="customRadioInline3">UPI</label>
    </div>
  </div>
  <div class="mt-3">
    <div class="paymentDiv col-md-12 mb-2">
      <label for="paymentAmount" class="payingClinic col-md-6">Paying(&#8377;) in Clinic</label>
      <input type="number" class="form-control input-font paymentAmount discountBox col-md-6" id="paymentAmount"
        [(ngModel)]="paymentAmount" (change)="changeAmount('payment')">
    </div>
    <div class="pendingDiv  col-md-12">
      <label for="pendingAmount" class="toPay col-md-6">Pending(&#8377;) to Pay in App</label>
      <input type="number" class="form-control input-font pendingAmount discountBox col-md-6" id="pendingAmount"
        [(ngModel)]="pendingAmount" readonly>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="offset-md-3">
    <button mat-button class="mat-raised-button mr-4 btn btn-primary btn-sm" (click)="confirmPayment()"
      [disabled]="disableConfirmButton ? true : null">Confirm</button>
    <button mat-button class="mat-raised-button mat-secondary" (click)="dialogRef.close(false)">Cancel</button>
  </div>
</mat-dialog-actions>
